import { getRequiredFields } from 'utils/form'
import constants from 'constants'

const fields = [
  {
    label: '',
    name: 'role',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },
  {
    label: '',
    name: 'planStatus',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },
  {
    label: 'Partner self assessment',
    name: 'partnerInterimAssessment',
    layout: 'fullWidth',
  },
  {
    label: 'Partner self assessment notes',
    name: 'partnerInterimAssessmentComments',
    layout: 'fullWidth',
  },
  {
    label: 'Partner self assessment',
    name: 'partnerFinalAssessment',
    layout: 'fullWidth',
  },
  {
    label: 'Partner self assessment notes',
    name: 'partnerFinalAssessmentComments',
    layout: 'fullWidth',
  },
  {
    label: 'Counselling partner assessment',
    name: 'counsellorInterimAssessment',
    layout: 'fullWidth',
  },
  {
    label: 'Counselling partner assessment',
    name: 'counsellorFinalAssessment',
    layout: 'fullWidth',
  },
  {
    label: 'Final agreed rating (BUL)',
    name: 'finalAgreedInterimAssessment',
    layout: 'fullWidth',
  },
  {
    label: 'Final agreed rating (BUL) notes',
    name: 'finalAgreedInterimAssessmentComments',
    layout: 'fullWidth',
  },
  {
    label: 'Final agreed rating (BUL)',
    name: 'finalAgreedFinalAssessment',
    layout: 'fullWidth',
  },
  {
    label: 'Final agreed rating (BUL) notes',
    name: 'finalAgreedFinalAssessmentComments',
    layout: 'fullWidth',
  },
  /* {
    label: 'Interim self assessment',
    name: 'interimCounsellee',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIf',
        fields: 'interimCounsellee|planStatus',
        error: 'Please select interim self assessment',
        conditions: constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT,
      },
    ],
  }, 
  {
    label: 'Final self assessment',
    name: 'finalCounselleeAssessment',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIf',
        fields: 'finalCounselleeAssessment|planStatus',
        error: 'Please select final self assessment',
        conditions: constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT,
      },
    ],
  }, */
  {
    label: 'Counselling partner assessment',
    name: 'interimCounsellor',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIfs',
        fields: 'interimCounsellor|planStatus|role',
        error: 'Please select interim assessment',
        conditions: `${constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED}|${constants.PARTNERPLAN.ROLE.CP}`,
      },
    ],
  },
  {
    label: constants.PARTNERPLAN.PROGRESS_LABEL.INTERIM_AGREED_WITH_COUNSELLEE,
    name: 'interimPlanAgreedWithCounsellee',
    validators: [
      {
        check: 'requiredCheckedIfs',
        fields: 'interimPlanAgreedWithCounsellee|planStatus|role',
        error: constants.PARTNERPLAN.ERROR_MESSAGE.INTERIM_AGREED_WITH_COUNSELLEE,
        conditions: `${constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED}|${constants.PARTNERPLAN.ROLE.CP}`,
      },
    ],
  },
  {
    label: 'Final assessment',
    name: 'finalCounsellorAssessment',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIfs',
        fields: 'finalCounsellorAssessment|planStatus|role',
        error: 'Please select final assessment',
        conditions: `${constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED}|${constants.PARTNERPLAN.ROLE.CP}`,
      },
    ],
  },
  {
    label: constants.PARTNERPLAN.PROGRESS_LABEL.FINAL_AGREED_WITH_COUNSELLEE,
    name: 'finalPlanAgreedWithCounsellee',
    validators: [
      {
        check: 'requiredCheckedIfs',
        fields: 'finalPlanAgreedWithCounsellee|planStatus|role',
        error: constants.PARTNERPLAN.ERROR_MESSAGE.FINAL_AGREED_WITH_COUNSELLEE,
        conditions: `${constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED}|${constants.PARTNERPLAN.ROLE.CP}`,
      },
    ],
  },
  /* {
    label: 'Add a note',
    name: 'interimCounselleeComments',
    layout: 'fullWidth',
    maxLength: 400,
    validators: [
      {
        check: 'requiredIf',
        fields: 'interimCounselleeComments|interimCounsellee',
        error: 'If you have selected "Not eligible" you must provide reasons in the note section.',
        conditions: constants.PARTNERPLAN.RATINGS.NOT_ELIGABLE,
      },
    ],
  }, */
  /* **use for notes dropdown selection**
  {
    label: 'Counselling partner notes',
    name: 'interimCounsellorComments',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIf',
        fields: 'interimCounsellorComments|interimCounsellor',
        error: 'If you have selected "Not eligible" you must provide reasons in the note section.',
        conditions: constants.PARTNERPLAN.RATINGS.NOT_ELIGABLE,
      },
      {
        check: 'isCounsellorCommentRequired',
        fields: 'interimCounsellor|partnerInterimAssessment|interimCounsellorComments',
        error: 'If the partner\'s self-assessment differs from the counselling assessment, please provide an explanation in the note section.',
        conditions: `${constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED}|${constants.PARTNERPLAN.ROLE.CP}`,
      },
    ],
  }, */
  {
    label: 'Counselling partner notes',
    name: 'interimCounsellorComments',
    layout: 'fullWidth',
    maxLength: 400,
    validators: [
      {
        check: 'requiredIf',
        fields: 'interimCounsellorComments|interimCounsellor',
        error: 'If you have selected "Not eligible" you must provide reasons in the note section.',
        conditions: constants.PARTNERPLAN.RATINGS.NOT_ELIGABLE,
      },      
      {
        check: 'requiredIfs',
        fields: 'interimCounsellorComments|planStatus|role',
        error: 'Please provide an explanation in the note section.',
        conditions: `${constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED}|${constants.PARTNERPLAN.ROLE.CP}`,
      },
    ],
  },
  /* {
    label: 'Add a note',
    name: 'interimCounsellorComments',
    layout: 'fullWidth',
    maxLength: 400,
    validators: [
      {
        check: 'requiredIf',
        fields: 'interimCounsellorComments|interimCounsellor',
        error: 'If you have selected "Not eligible" you must provide reasons in the note section.',
        conditions: constants.PARTNERPLAN.RATINGS.NOT_ELIGABLE,
      },
    ],
  }, 
  {
    label: 'Add a note',
    name: 'finalCounselleeComments',
    layout: 'fullWidth',
    maxLength: 400,
    validators: [
      {
        check: 'requiredIf',
        fields: 'finalCounselleeComments|finalCounselleeAssessment',
        error: 'If you have selected "Not eligible" you must provide reasons in the note section.',
        conditions: constants.PARTNERPLAN.RATINGS.NOT_ELIGABLE,
      },
    ],
  }, */
  /* **use for notes dropdown selection**
  {
    label: 'Counselling partner notes',
    name: 'finalCounsellorComments',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIf',
        fields: 'finalCounsellorComments|finalCounsellorAssessment',
        error: 'If you have selected "Not eligible" you must provide reasons in the note section.',
        conditions: constants.PARTNERPLAN.RATINGS.NOT_ELIGABLE,
      },
      {
        check: 'isCounsellorCommentRequired',
        fields: 'finalCounsellorAssessment|finalCounselleeAssessment|finalCounsellorComments',
        error: 'If the partner\'s self-assessment differs from the counselling assessment, please provide an explanation in the note section.',
        conditions: `${constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED}|${constants.PARTNERPLAN.ROLE.CP}`,
      },
    ],
  }, */
  {
    label: 'Counselling partner notes',
    name: 'finalCounsellorComments',
    layout: 'fullWidth',
    maxLength: 400,
    validators: [
      {
        check: 'requiredIf',
        fields: 'finalCounsellorComments|finalCounsellorAssessment',
        error: 'If you have selected "Not eligible" you must provide reasons in the note section.',
        conditions: constants.PARTNERPLAN.RATINGS.NOT_ELIGABLE,
      },      
      {
        check: 'requiredIfs',
        fields: 'finalCounsellorAssessment|planStatus|role',
        error: 'Please provide an explanation in the note section',
        conditions: `${constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED}|${constants.PARTNERPLAN.ROLE.CP}`,
      },
    ],
    error: 'Please provide an explanation in the note section.',
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/PartnerPlanForm.js